import { useQuery } from 'react-query';

import { getTrapDetailHeatMapChart } from 'api/traps/Trap/getTrapDetailHeatMapChart';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export const useGetTrapDetailHeatMapChartData = (
  slug: string,
  type: TrapType,
  start_datetime: string,
  end_datetime: string,
  isCompare?: boolean,
  isSRBM: boolean = false,
) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    ['TrapDetailHeatMapChartData', start_datetime, end_datetime, slug, isCompare],
    () => getTrapDetailHeatMapChart(slug, type, start_datetime, end_datetime),
    {
      refetchOnWindowFocus: false,
      enabled: !isSRBM,
    },
  );

  return { data, refetch, isLoading, isFetching };
};

export default useGetTrapDetailHeatMapChartData;
